import {
  Skeleton as MuiSkeleton, Stack as MuiStack,
} from '@mui/material';
import styled from 'styled-components';

const Stack = styled(MuiStack)`
max-width: 100%;
width: 100%;
`;

const Skeleton = styled(MuiSkeleton)`
width: 100%;
margin-bottom: ${({ theme }) => theme.spacing(2)};
`;

export { Stack, Skeleton };
